var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThemeSetup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77 38.5C77 59.763 59.763 77 38.5 77C17.237 77 0 59.763 0 38.5C0 17.237 17.237 0 38.5 0C59.763 0 77 17.237 77 38.5Z",
    fill: "#FDC5C5",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9658 28.615V20.04C24.4771 21.8404 28.3629 22.7886 32.3088 22.808C38.7908 22.808 40.8838 19.5 48.1078 19.5C50.4805 19.641 52.817 20.1494 55.0338 21.007V28.615M55.0338 28.615V40.161C55.0338 43.536 51.1178 43.807 47.5398 43.807C43.9618 43.807 41.0018 45.315 41.0018 48.702C41.0018 50.23 42.0028 50.558 42.0028 52.922C42.0028 55.286 40.7478 56.5 37.9998 56.5C35.2518 56.5 33.9968 55.285 33.9968 52.921C33.9968 50.557 34.9978 50.231 34.9978 48.701C34.9978 45.314 32.0378 43.807 28.4598 43.807C24.8818 43.807 20.9658 43.537 20.9658 40.161V28.615M20.9658 28.615H55.0338H20.9658Z",
    fill: "#DB3539"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9658 28.615V20.04C24.4771 21.8404 28.3629 22.7886 32.3088 22.808C38.7908 22.808 40.8838 19.5 48.1078 19.5C50.4805 19.641 52.817 20.1494 55.0338 21.007V28.615M55.0338 28.615V40.161C55.0338 43.536 51.1178 43.807 47.5398 43.807C43.9618 43.807 41.0018 45.315 41.0018 48.702C41.0018 50.23 42.0028 50.558 42.0028 52.922C42.0028 55.286 40.7478 56.5 37.9998 56.5C35.2518 56.5 33.9968 55.285 33.9968 52.921C33.9968 50.557 34.9978 50.231 34.9978 48.701C34.9978 45.314 32.0378 43.807 28.4598 43.807C24.8818 43.807 20.9658 43.537 20.9658 40.161V28.615M20.9658 28.615H55.0338",
    stroke: "#DDDDDD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeSetup);
export default __webpack_public_path__ + "static/media/ThemeSetup.d5b71ab0fbbadf90b8993c931f1c8e96.svg";
export { ForwardRef as ReactComponent };